import React from 'react';
import styled from 'styled-components';
import AppStoreLogo from './assets/AppStore.svg';
import GooglePlayLogo from './assets/GooglePlay.svg';
import { Icon } from 'styleguide/Icons/Icon';
import { P2 } from 'styleguide/Texts';
import { colors } from 'styleguide/colors';
import { t } from 'translations/t';
import { formatNumber } from 'translations/formatters';

const RatingStarsContainer = styled.div`
  display: grid;
  grid-template-columns: auto auto auto auto auto;
  gap: 4px;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
`;

const RatingStars = () => (
  <RatingStarsContainer>
    <Icon type="star" tint={colors.primary} />
    <Icon type="star" tint={colors.primary} />
    <Icon type="star" tint={colors.primary} />
    <Icon type="star" tint={colors.primary} />
    <Icon type="star" tint={colors.primary} />
  </RatingStarsContainer>
);

const MOBILE_BREAKPOINT = 1270;

const RatingContainer = styled.div`
  margin-top: 32px;
  margin-bottom: 56px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-inline-start: auto;
  margin-inline-end: auto;
  width: 580px;
  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    grid-template-columns: 1fr;
    row-gap: 32px;
    margin-bottom: 32px;
    max-width: 360px;
  }
`;

export const Ratings = () => {
  return (
    <RatingContainer>
      <div>
        <RatingStars />
        <P2 style={{ marginBottom: 4 }}>
          {t('web.paywall.ratings.starsAndReviews', {
            numStars: <strong>{formatNumber(4.9)}</strong>,
            numReviews: <strong>{formatNumber(192000)}</strong>,
          })}
        </P2>
        <AppStoreLogo />
      </div>
      <div>
        <RatingStars />
        <P2 style={{ marginBottom: 4 }}>
          {t('web.paywall.ratings.starsAndReviews', {
            numStars: <strong>{formatNumber(4.9)}</strong>,
            numReviews: <strong>{formatNumber(173000)}</strong>,
          })}
        </P2>
        <GooglePlayLogo />
      </div>
    </RatingContainer>
  );
};
